export default __webpack_public_path__ + "static/media/mastercard-logo.ee85d3d4.svg";